let mutations = {
    // 设置选中的tab
    SET_CHOSEN_TAB: (state, val) => {
        state.chosen_tab = val;
    },
    // 选中平台
    CHOSEN_PLATFORM: (state, val) => {
        let icons = state.plat_slide_icons;
        for (let i = 0; i < icons.length; i++) {
            val == icons[i] ? (icons[i].chosen = true) : (icons[i].chosen = false);
        }
    },
    // 设置是否登录
    SET_IS_LOGIN: (state, val) => {
        state.is_login = val;
    },
    // 是否可埋点
    SET_CAN_TRACK: (state, val) => {
        state.can_track = val;
    },
    // 设置会员身份
    SET_MEMBERSHIP_CLASSIFY: (state, val) => {
        state.membership_classify = val;
    },
    // 设置xdevice
    SET_XDEVICE: (state, val) => {
        state.xdevice = val
    },
    // 设置用户id
    SET_USERID: (state, val) => {
        state.user_id = val
    },
    // 是否越狱
    SET_IS_JAILBROKEN_PHONE: (state, val) => {
        state.is_jailbroken_phone = val
    },
    // 设置appversion
    SET_APP_VERSION: (state, val) => {
        state.app_version = val
    },
    // 显示全局loading
    SET_SHOW_LOADING: (state, val) => {
        state.show_loading = val;
    },
    // 显示活动规则
    SET_SHOW_RULE: (state, val) => {
        state.show_rule = val;
    },
    // 显示分享弹窗
    SET_SHOW_SHARE: (state, val) => {
        state.show_share = val;
    },
    // 显示手机号收集弹窗
    SET_SHOW_PHONE_NUMBER: (state, val) => {
        state.show_phone_number = val;
    },
    // 显示挽留弹窗
    SET_SHOW_DETENTION: (state, val) => {
        state.show_detention = val;
    },
    // 设置手机号预约状态
    SET_RESERVATION_STATUS: (state, val) => {
        state.reservation_status = val;
    },
    // 设置活动阶段，埋点子页面名称
    SET_ACTIVITY_STATUS: (state, val) => {
        let map = {
            1: '预约页',
            2: '购买页',
            3: '领取页',
            4: '活动结束页',
        };
        state.activity_status = val;
        state.subname = map[val];
    },
    // 设置剩余开通次数
    SET_CAN_ASSIGN_COUNT: (state, val) => {
        state.can_assign_count = val
    },
    // 设置服务器时间
    SET_SEVER_TIME: (state, val) => {
        state.server_time = val;
    },
    // 设置活动结束时间
    SET_ACTIVITY_END_TIME: (state, val) => {
        state.activity_end_time = val;
    },
    // 设置平台icons
    SET_PLAT_ICONS: (state, val) => {
        // 先清空
        state.plat_icons = [];
        state.plat_icons = val;
    },
    // 设置售卖总数量
    SET_TOTAL_COUNT: (state, val) => {
        state.total_count = val;
    },
    // 设置已售数量
    SET_SALE_COUNT: (state, val) => {
        state.sale_count = val;
    },
    // 设置开通会员价格
    SET_OPEN_PRICE: (state, val) => {
        console.log("套餐价格", val);
        state.open_price = val;
    },
    // 刷新首页接口
    SET_REFRESH_DATA: (state, val) => {
        state.refresh_data = val;
    },
    // 刷新价格接口
    SET_REFRESH_MEMBERGOOD_LIST: (state, val) => {
        state.refresh_membergood_list = val;
    },
    // 组件开始初始化
    SET_COMP_INIT: (state, val) => {
        state.comp_init = val;
    },
    // 倒计时时间到
    SET_TIME_END: (state, val) => {
        state.time_end = val;
    },
    // 进度条长度变化
    SET_PROGRESS_WIDTH: (state, val) => {
        state.progress_width = val;
    },
    // 判断ipad
    SET_IS_IPAD: (state, val) => {
        state.is_ipad = val;
    },
    // 设置会员剩余时长
    SET_MEMBER_REMAIN_DAYS: (state, val) => {
        state.member_remain_days = val;
    },
    // 设置显示9部作品
    SET_SHOW_NINE: (state, val) => {
        state.show_nine = val;
    },
    // 登录组件是否初始化
    SET_OPEN_BTN_INIT: (state, val) => {
        state.open_btn_init = val;
    },
    // 从百度进入是否开通达到4次
    SET_OPEN_FROM_BAIDU: (state, val) => {
        state.baidu_open_disable = val;
    },
    // 从百度进入唤起端外支付
    SET_CALL_APPPAY: (state, val) => {
        state.call_apppay = val
    }
}

export { mutations }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/store/mutations.js